// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ArkivRouteImport } from './routes/arkiv'
import { Route as ArtiklerRouteImport } from './routes/artikler'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BogmaerkerRouteImport } from './routes/bogmaerker'
import { Route as DetSkerRouteImport } from './routes/det-sker'
import { Route as OmRouteImport } from './routes/om'
import { Route as OmKuratorenRouteImport } from './routes/om-kuratoren'
import { Route as OpskrifterRouteImport } from './routes/opskrifter'
import { Route as StemningerRouteImport } from './routes/stemninger'
import { Route as StoetRouteImport } from './routes/stoet'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as VideoRouteImport } from './routes/video'
import { Route as AdminKuratorRouteImport } from './routes/admin_.kurator'
import { Route as AdminLoginRouteImport } from './routes/admin_.login'
import { Route as ArtikelIdRouteImport } from './routes/artikel.$id'
import { Route as DagbogDateRouteImport } from './routes/dagbog.$date'
import { Route as EmneTopicRouteImport } from './routes/emne.$topic'
import { Route as NyhedsbrevFrekvensSkiftetRouteImport } from './routes/nyhedsbrev.frekvens-skiftet'
import { Route as OpskriftIdRouteImport } from './routes/opskrift.$id'
import { Route as TilmeldBekraeftRouteImport } from './routes/tilmeld.bekraeft'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const ArkivRoute = ArkivRouteImport.update({
            id: '/arkiv',path: '/arkiv',getParentRoute: () => rootRouteImport
          })
const ArtiklerRoute = ArtiklerRouteImport.update({
            id: '/artikler',path: '/artikler',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BogmaerkerRoute = BogmaerkerRouteImport.update({
            id: '/bogmaerker',path: '/bogmaerker',getParentRoute: () => rootRouteImport
          })
const DetSkerRoute = DetSkerRouteImport.update({
            id: '/det-sker',path: '/det-sker',getParentRoute: () => rootRouteImport
          })
const OmRoute = OmRouteImport.update({
            id: '/om',path: '/om',getParentRoute: () => rootRouteImport
          })
const OmKuratorenRoute = OmKuratorenRouteImport.update({
            id: '/om-kuratoren',path: '/om-kuratoren',getParentRoute: () => rootRouteImport
          })
const OpskrifterRoute = OpskrifterRouteImport.update({
            id: '/opskrifter',path: '/opskrifter',getParentRoute: () => rootRouteImport
          })
const StemningerRoute = StemningerRouteImport.update({
            id: '/stemninger',path: '/stemninger',getParentRoute: () => rootRouteImport
          })
const StoetRoute = StoetRouteImport.update({
            id: '/stoet',path: '/stoet',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const VideoRoute = VideoRouteImport.update({
            id: '/video',path: '/video',getParentRoute: () => rootRouteImport
          })
const AdminKuratorRoute = AdminKuratorRouteImport.update({
            id: '/admin_/kurator',path: '/admin/kurator',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin_/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const ArtikelIdRoute = ArtikelIdRouteImport.update({
            id: '/artikel/$id',path: '/artikel/$id',getParentRoute: () => rootRouteImport
          })
const DagbogDateRoute = DagbogDateRouteImport.update({
            id: '/dagbog/$date',path: '/dagbog/$date',getParentRoute: () => rootRouteImport
          })
const EmneTopicRoute = EmneTopicRouteImport.update({
            id: '/emne/$topic',path: '/emne/$topic',getParentRoute: () => rootRouteImport
          })
const NyhedsbrevFrekvensSkiftetRoute = NyhedsbrevFrekvensSkiftetRouteImport.update({
            id: '/nyhedsbrev/frekvens-skiftet',path: '/nyhedsbrev/frekvens-skiftet',getParentRoute: () => rootRouteImport
          })
const OpskriftIdRoute = OpskriftIdRouteImport.update({
            id: '/opskrift/$id',path: '/opskrift/$id',getParentRoute: () => rootRouteImport
          })
const TilmeldBekraeftRoute = TilmeldBekraeftRouteImport.update({
            id: '/tilmeld/bekraeft',path: '/tilmeld/bekraeft',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,ArkivRoute: ArkivRoute,ArtiklerRoute: ArtiklerRoute,AuthRoute: AuthRoute,BogmaerkerRoute: BogmaerkerRoute,DetSkerRoute: DetSkerRoute,OmRoute: OmRoute,OmKuratorenRoute: OmKuratorenRoute,OpskrifterRoute: OpskrifterRoute,StemningerRoute: StemningerRoute,StoetRoute: StoetRoute,UnsubscribeRoute: UnsubscribeRoute,VideoRoute: VideoRoute,AdminKuratorRoute: AdminKuratorRoute,AdminLoginRoute: AdminLoginRoute,ArtikelIdRoute: ArtikelIdRoute,DagbogDateRoute: DagbogDateRoute,EmneTopicRoute: EmneTopicRoute,NyhedsbrevFrekvensSkiftetRoute: NyhedsbrevFrekvensSkiftetRoute,OpskriftIdRoute: OpskriftIdRoute,TilmeldBekraeftRoute: TilmeldBekraeftRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)